var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":this.pageSize,"total":this.total,"current-page":this.pageNum,"hide-on-single-page":""},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }